<mat-spinner class="margin-auto" *ngIf="loading==true"></mat-spinner>
<div *ngIf="error!=''">{{error}}</div>
<div class="searchResults" *ngIf="loading==false && error==''">
  <div class="general-search row baseline">
      <div class="search-title flex-1">חיפוש וסינון</div>
      <div class="quick-search row baseline flex-1">
          <div class="flex:1">טקסט חופשי</div>
          <input class="float-l flex-1" placeholder="הקלד/הקלידי כאן את החיפוש שלך" [(ngModel)]="searchText" (input)="filter()"/>
      </div>
  </div>
  <div class="split"></div>
  <button mat-raised-button color="primary" (click)="openExSearch()" style="display:none">
    <span *ngIf="exSearchIsOpen==false" class="center-v-align"><mat-icon title=""><mat-icon>search</mat-icon></mat-icon>חיפוש מתקדם</span>
    <span *ngIf="exSearchIsOpen==true" class="center-v-align"><mat-icon title="סגור"><mat-icon>expand_less</mat-icon></mat-icon>סגור</span>
  </button>
  <div class="exSearch shadow" *ngIf="exSearchIsOpen==true">
    <form>
      <div class="ex-search-params">
        <div *ngFor="let col of filterColumns">
          <div class="one-prop">
            <container-element [ngSwitch]="col.type" class="w-100">
              <span *ngSwitchCase="'lookup'">
                <mat-form-field class="w-100">
                  <mat-label>{{col.title}}</mat-label>
                  <mat-select [(ngModel)]="searchObj[col.field]" [name]="'ddl_'+col.field">
                    <mat-option *ngFor="let x of col.filterOptions;let i=index" [value]="x.key">{{x.value}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span *ngSwitchCase="'date_range'">
                <div class="date-label">{{col.title}}</div>
                <div class="row date-range">
                  <mat-form-field class="flex-1">
                    <mat-label>מתאריך:</mat-label>
                    <input placeholder="מתאריך" matInput type="date" [name]="'txt_'+col.field+'_start'" [(ngModel)]="searchObj[col.field+'_start']" />
                  </mat-form-field>
                  <mat-form-field class="flex-1">
                    <mat-label>עד תאריך:</mat-label>
                    <input placeholder="עד תאריך" matInput type="date" [name]="'txt_'+col.field+'_end'" [(ngModel)]="searchObj[col.field+'_end']"/>
                  </mat-form-field>
                </div>
              </span>
              <span *ngSwitchCase="'date_start'">
                <div class="date-label">{{col.title}}</div>
                <mat-form-field class="w-100">
                  <mat-label>מתאריך:</mat-label>
                  <input placeholder="מתאריך" matInput type="date" [name]="'txt_'+col.field+'_start'" [(ngModel)]="searchObj[col.field+'_start']"/>
                </mat-form-field>
              </span>
              <span *ngSwitchCase="'date_end'">
                <div class="date-label">{{col.title}}</div>
                <mat-form-field class="w-100">
                  <mat-label>עד תאריך:</mat-label>
                  <input placeholder="עד תאריך" matInput type="date" [name]="'txt_'+col.field+'_end'" [(ngModel)]="searchObj[col.field+'_end']" />
                </mat-form-field>
              </span>
              <span *ngSwitchDefault>
                <mat-form-field class="w-100">
                  <mat-label>{{col.title}}</mat-label>
                  <input matInput [name]="'txt_'+col.field" [(ngModel)]="searchObj[col.field]"/>
                </mat-form-field>
              </span>
            </container-element>
          </div>
        </div>
        <span>
      <button mat-raised-button color="primary" type="button" (click)="exFilter()"><span class="center-v-align"><mat-icon>search</mat-icon>חיפוש</span></button>&nbsp;
        </span>
      <button mat-raised-button color="primary" type="button" (click)="clearFilter()"><span class="center-v-align"><mat-icon>clear_all</mat-icon>ניקוי</span></button>
      </div>
    </form>
  </div>
  <div class="details row">
    <div class="flex-1" *ngIf="searchAlign=='right'"></div>
    <div class="flex-3 row baseline">
      <span class="flex-1">{{resultCountMsg}}</span>
      <div class="paging flex-1" *ngIf="data.length>pageSize">
        <span class="span-as-link" (click)="paging(-1,false)"><<</span>
        <span class="span-as-link" (click)="paging(0,false)">הקודם</span>
        <span class="span-as-link" (click)="paging(0,true)">הבא</span>
        <span class="span-as-link" (click)="paging(-1,true)">>></span>
      </div>

    </div>
  </div>
  <div class="row">
    <div class="flex-1" *ngIf="searchAlign=='right'">
      <form>
        <div class="ex-search-params right-search">
          <div *ngFor="let col of filterColumns">
            <div class="one-prop">
              <container-element [ngSwitch]="col.type" class="w-100">
                <span *ngSwitchCase="'lookup'">
                  <mat-form-field class="w-100">
                    <mat-label>{{col.title}}</mat-label>
                    <mat-select [(ngModel)]="searchObj[col.field]" [name]="'ddl_'+col.field" (selectionChange)="exFilter()">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let x of col.filterOptions;let i=index" [value]="x.key">{{x.value}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span *ngSwitchCase="'date_range'">
                  <div class="date-label">{{col.title}}</div>
                  <mat-form-field class="w-100">
                    <mat-label>מתאריך:</mat-label>
                    <input placeholder="מתאריך" matInput type="date" [name]="'txt_'+col.field+'_start'" [(ngModel)]="searchObj[col.field+'_start']" (input)="exFilter()" />
                  </mat-form-field>
                  <mat-form-field class="w-100">
                    <mat-label>עד תאריך:</mat-label>
                    <input placeholder="עד תאריך" matInput type="date" [name]="'txt_'+col.field+'_end'" [(ngModel)]="searchObj[col.field+'_end']" (input)="exFilter()" />
                  </mat-form-field>
                </span>
                <span *ngSwitchCase="'date_start'">
                  <div class="date-label">{{col.title}}</div>
                  <mat-form-field class="w-100">
                    <mat-label>מתאריך:</mat-label>
                    <input placeholder="מתאריך" matInput type="date" [name]="'txt_'+col.field+'_start'" [(ngModel)]="searchObj[col.field+'_start']" (input)="exFilter()" />
                  </mat-form-field>
                </span>
                <span *ngSwitchCase="'date_end'">
                  <div class="date-label">{{col.title}}</div>
                  <mat-form-field class="w-100">
                    <mat-label>עד תאריך:</mat-label>
                    <input placeholder="עד תאריך" matInput type="date" [name]="'txt_'+col.field+'_end'" [(ngModel)]="searchObj[col.field+'_end']" (input)="exFilter()" />
                  </mat-form-field>
                </span>
                <span *ngSwitchDefault>
                  <mat-form-field class="w-100">
                    <mat-label>{{col.title}}</mat-label>
                    <input matInput [name]="'txt_'+col.field" [(ngModel)]="searchObj[col.field]" (input)="exFilter()" />
                  </mat-form-field>
                </span>
              </container-element>
            </div>
          </div>
        </div>
      </form>
    </div><!--div search form-->
    <div class="flex-3">
      <div *ngIf="mode=='table'">
        <table cellpadding="10">
          <thead>
            <tr>
              <th *ngFor="let col of columns">
                <span class="span-as-link" (click)="sortData(col)">{{col.title}}</span>
                <span *ngIf="sortField == col.field && sortUp == true"><mat-icon>text_rotate_up</mat-icon></span>
                <span *ngIf="sortField == col.field && sortUp == false"><mat-icon>text_rotation_down</mat-icon></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data.slice((startPage-1)*pageSize,startPage*pageSize)">
              <td *ngFor="let col of columns">
                <span *ngIf="col.type!='routerLink'" [innerHTML]="row[col.field]"></span>
                <a *ngIf="col.type=='routerLink'" [routerLink]="col.url" [queryParams]="row[col.field]">{{col.text}}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="mode=='view'">
        <div>
          <div class="one-res" *ngFor="let row of data.slice((startPage-1)*pageSize,startPage*pageSize)">
            <div class="one-prop" *ngFor="let col of columns" [class]="col.type+' '+col.design+'-'+row[col.field]">
              <div *ngIf="col.type=='linkTitle'">
                <a [routerLink]="col.url" [queryParams]="row[col.field+'_params']">{{row[col.field]}}</a>
              </div>
              <div *ngIf="col.type!='linkTitle'">
                <div *ngIf="!col.design"><b>{{col.title}}</b></div>
                <div>
                  <!--<span *ngIf="col.type!='routerLink'" [innerHTML]="row[col.field]"></span>
                  <a *ngIf="col.type=='routerLink'" [routerLink]="col.url" [queryParams]="row[col.field]">{{col.text}}</a>-->
                  <container-element [ngSwitch]="col.type">
                    <span *ngSwitchCase="'routerLink'">
                      <a *ngIf="!col.condition || isCondition(row,col)" [routerLink]="col.url" [queryParams]="row[col.field+'_params']">{{col.text}}</a>
                      <span *ngIf="col.condition && !isCondition(row,col)" [innerHTML]="col.condition.expiredText"></span>
                    </span>
                    <span *ngSwitchCase="'payment'">
                      <span *ngIf="isPayment(row[col.field])">
                        <div><span [innerHTML]="row[col.field].toFixed(2)"></span> ש"ח</div>
                        <span class="span-as-link" *ngIf="row[col.params.encryptPaymentCol]" (click)="pay(row,col.params.encryptPaymentCol)">לתשלום המכרז</span>
                        <div *ngIf="row[col.params.encryptPaymentCol]==''">ERROR!</div>
                      </span>
                    </span>
                    <span *ngSwitchCase="'date_start'" [innerHTML]="row[col.field+'_text']"></span>
                    <span *ngSwitchCase="'date_end'" [innerHTML]="row[col.field+'_text']"></span>
                    <span *ngSwitchCase="'date_range'" [innerHTML]="row[col.field+'_text']"></span>
                    <span *ngSwitchCase="'lookup'" [innerHTML]="row[col.field+'_text']"></span>
                    <span *ngSwitchDefault [innerHTML]="row[col.field]"></span>
                  </container-element>
                </div>
              </div>
            </div><!--one-prop-->
          </div><!--one-res-->
        </div>
        <div class="paging" *ngIf="data.length>pageSize">
          <span class="span-as-link" (click)="paging(-1,false)"><<</span>
          <span class="span-as-link" (click)="paging(0,false)">הקודם</span>
          <span class="span-as-link" (click)="paging(0,true)">הבא</span>
          <span class="span-as-link" (click)="paging(-1,true)">>></span>
        </div>
      </div>
    </div>
  </div>
